/** HQ Naturals portals — light mode only (theme toggle hidden). */
export const THEME_STORAGE_KEY = "theme";

export const getPreferredTheme = () => "light";

export const getStoredTheme = () => "light";

export const applyThemeToDocument = (_nextTheme) => {
  const resolvedTheme = "light";

  if (typeof document === "undefined") {
    return resolvedTheme;
  }

  const root = document.documentElement;
  root.dataset.theme = resolvedTheme;
  root.classList.remove("dark");

  if (document.body) {
    document.body.dataset.theme = resolvedTheme;
    document.body.classList.remove("dark");
  }

  try {
    localStorage.setItem(THEME_STORAGE_KEY, resolvedTheme);
  } catch {
    /* ignore */
  }

  return resolvedTheme;
};
